import { Alert } from "antd";

const STATUS_ALERT_CONFIG = {
    OTC_QUOTE_SHARED: {
        type: "info",
        message: "A custom rate has been set for your request.",
        description: "Review the rate details below and accept or reject within the agreed window.",
        className: "bg-purple-100 border-0 [&_.ant-alert-title]:!text-purple-700 [&_.ant-alert-description]:!text-purple-900 [&_.ant-alert-icon]:!text-purple-600",
    },
    IN_PROGRESS: {
        type: "info",
        message: "Request in Progress",
        description: "BRNX is working on your request. You'll see the custom rate here once it's ready.",
        className: "bg-blue-200 border-0 [&_.ant-alert-title]:!text-blue-700 [&_.ant-alert-description]:!text-blue-900 [&_.ant-alert-icon]:!text-blue-600",
    },
    REJECTED: {
        type: "error",
        message: "Request Rejected",
        description: "The custom rate for your request has been rejected. Please contact support for further assistance.",
        className: "bg-red-100 border-0 [&_.ant-alert-title]:!text-red-700 [&_.ant-alert-description]:!text-red-900 [&_.ant-alert-icon]:!text-red-600",
    },
    ACCEPTED: {
        type: "success",
        message: "Request Accepted",
        description: "The custom rate for your request has been accepted. Please proceed to payment.",
        className: "bg-green-100 border-0 [&_.ant-alert-title]:!text-green-700 [&_.ant-alert-description]:!text-green-900 [&_.ant-alert-icon]:!text-green-600",
    },
    PENDING:{
        type: "warning",
        message: "Request Pending",
        description: "Your request is pending review. You'll be notified once a decision is made.",
        className: "bg-yellow-100 border-0 [&_.ant-alert-title]:!text-yellow-700 [&_.ant-alert-description]:!text-yellow-900 [&_.ant-alert-icon]:!text-yellow-600",
    }
};

// Status-driven Alert banner — colors mirror the Badge component's palette per status.
const StatusAlert = ({ status }) => {
    const config = STATUS_ALERT_CONFIG[status];
    if (!config) return null;

    return (
        <Alert
            title={config.message}
            description={config.description}
            type={config.type}
            showIcon
            className={config.className}
        />
    );
};

export default StatusAlert;
